
export default function TrustStatistics() {
  return (
    <section className="w-full bg-[#1A1A1A] py-12 md:py-16 px-4 md:px-8 lg:px-16">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 text-center">
          <div className="flex flex-col items-center">
            <div
              className="text-[42px] md:text-[56px] font-black text-[#F2C612] mb-2"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              25+
            </div>
            <div
              className="text-[16px] md:text-[18px] text-white font-medium"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Years in Business
            </div>
          </div>

          <div className="flex flex-col items-center">
            <div
              className="text-[42px] md:text-[56px] font-black text-[#F2C612] mb-2"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              10,000+
            </div>
            <div
              className="text-[16px] md:text-[18px] text-white font-medium"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Projects Completed
            </div>
          </div>

          <div className="flex flex-col items-center">
            <div
              className="text-[42px] md:text-[56px] font-black text-[#F2C612] mb-2"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              500+
            </div>
            <div
              className="text-[16px] md:text-[18px] text-white font-medium"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Trusted Stockists
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}